import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerContextSmartComponent } from './borrower-context-smart/borrower-context-smart.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    declarations: [
        BorrowerContextSmartComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatChipsModule,
        MatDividerModule,
        MatProgressSpinnerModule
    ],
    exports: [
        BorrowerContextSmartComponent
    ]
})
export class BorrowerContextModule { }
